import { AxiosResponse } from 'axios';

import { API } from '../../utils/axios';

class MeetingService {
  static getZoomCallSignature(params: {
    mn: string | number;
    role: string | number;
  }): Promise<any> {
    return API.get<any, AxiosResponse<any>>(
      `v1/resources/ZoomSignature?mn=${params.mn}&role=${params.role}`,
    ).then((res) => res.data);
  }

  // Patient join outcomes, logged server-side as ZOOM_JOIN next to the provider's (DI-340).
  // Fire and forget: telemetry must never block or fail a join.
  static reportJoinEvent(params: {
    event: 'joined' | 'join-error' | 'init-error' | 'socket-closed' | 'no-meeting';
    visitId?: string;
    meetingNumber?: string | number;
    errorCode?: number;
    detail?: string;
  }): void {
    API.post('v1/resources/ZoomJoinEvent', {
      ...params,
      meetingNumber: params.meetingNumber !== undefined ? String(params.meetingNumber) : undefined,
    }).catch(() => undefined);
  }
}

export default MeetingService;
